import styled from 'styled-components';

export const SortTagStyles = styled.div`
	.sort-number {
		display: flex;
		align-items: center;
		height: 20px;
		border-radius: 1rem;
		padding: 0 0.4rem;
		background: ${(props) => props.theme.v3.colors.gray[4]};
		text-align: center;
	}
`;
